import { NumberedTileMeta, TileSize } from "game-common/models"
import { contentSheetResource } from "../content_textures"

export interface ArtPixels { data: ArrayLike<number>; width: number; height: number }

/**
 * A composite's art as RGBA, laid out as TileTextureExtractor draws it, read from the original atlas
 * pixels on a canvas: never a GPU readback of a generated texture. Undefined until the tileset's sheet
 * has loaded, or where there is no canvas to draw on. Callers keep what they derive, not the pixels.
 */
export const compositeArtPixels = (tilesetId: string, columns: number, children: NumberedTileMeta[]): ArtPixels | undefined => {
    const frames = contentSheetResource(tilesetId)?.textures
    if (!frames || !children.length) return undefined
    const cells = children.map(child => ({ tile: child.tileNumber, x: (child.tileNumber - 1) % columns, y: Math.floor((child.tileNumber - 1) / columns) }))
    const left = Math.min(...cells.map(c => c.x)), top = Math.min(...cells.map(c => c.y))
    const canvas = document.createElement("canvas")
    canvas.width = (Math.max(...cells.map(c => c.x)) - left + 1) * TileSize
    canvas.height = (Math.max(...cells.map(c => c.y)) - top + 1) * TileSize
    const context = canvas.getContext("2d")
    if (!context) return undefined
    for (const cell of cells) {
        const texture = frames[`${tilesetId}-${cell.tile}`]
        const source = (texture?.baseTexture?.resource as any)?.source
        if (!source) return undefined
        const frame = texture.frame
        context.drawImage(source, frame.x, frame.y, frame.width, frame.height,
            (cell.x - left) * TileSize, (cell.y - top) * TileSize, TileSize, TileSize)
    }
    return { data: context.getImageData(0, 0, canvas.width, canvas.height).data, width: canvas.width, height: canvas.height }
}
